export default __webpack_public_path__ + "static/12-5035378105a953322e60505db5a45495.webp";